import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchCompanyList, fetchCompanyProfile, fetchJobListByCompany } from "./CompanyListAPI";


const initialState = {
  data: [],
  total: 0,
  loading: false,
  error: null,
};

export const fetchCompanyListAsync = createAsyncThunk(
  "companies/fetch",
  async (page, { rejectWithValue }) => {
    try {
      const data = await fetchCompanyList(page);

      const resp = data?.response;
      // console.log("data's response data", data.response.data)
      // console.log("resp total", resp.total)
      // console.log("resp data", resp.data)
      // return resp;
      return {
        companies: resp.data,  // The array of job data
        totalCompanies: resp.total,  
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// export const fetchJobListByCompanyAsync = createAsyncThunk(
//   "company/fetch",
//   async ({uuid}, { rejectWithValue }) => {
//     try {
//       const data = await fetchJobListByCompany(uuid);

//       const resp = data?.response?.data;
//       console.log("job list", data.response.data)
//       return resp;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );



const CompanyListSlice = createSlice({
  name: "CompanyList",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchCompanyListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

  },
});

export const selectCompanies = (state) => state.companies.data.companies;
export const selectTotalCompanies = (state) => state.companies.data.totalCompanies;
// export const selectCompanyJobs = (state) => state.jobsByCompany.data;


export default CompanyListSlice.reducer;
